import React, { RefObject } from "react"
import { Box, Stack, SxProps, Theme, Typography } from "@mui/material"
import { ArrowLeftOutlined, ArrowRightOutlined } from "@mui/icons-material"
import { ContentList } from "components/home/content-list-container/content-list/content-list"
import { ContentListModel } from "models"
import { Link } from "react-router-dom"

import "./style.css"

export interface CarouselProps {
	contentLists: ContentListModel[]
}

const scrollSpeed = 200
const scrollDuration = 500

export class ContentListCarousel extends React.Component<CarouselProps, {}>
{
	private contentListRef: RefObject<ContentList>;
	private wrappingCarouselScrollRef: RefObject<HTMLElement> = React.createRef();

	private scrollLeft = (index: number) => {

		//console.log(document!.getElementById("carousel" + index)!.style.transform!)
		if (document!.getElementById("carousel" + index)!.style.transform! === "") {
			document!.getElementById("carousel" + index)!.style.zIndex = (999 - index).toString()
			document!.getElementById("carousel" + index)!.style.transform = "translate(0px,0px)"
			let translate = document!.getElementById("carousel" + index)!.style.transform.slice(10)
			translate = translate.split("p")[0]
			let increase: number = parseInt(translate)
			increase += scrollSpeed
			if (increase > 0) { //end content list animation
				// document!.getElementById("carousel" + index)!.animate({transform: "translate("+(scrollSpeed).toString()+"px,0px)"}, {duration:scrollDuration}).finished.then(() =>{ 
				// document!.getElementById("carousel" + index)!.style.transform = "translate("+(scrollSpeed).toString()+"px,0px)"
				// document!.getElementById("carousel" + index)!.animate({transform: "translate("+(0).toString()+"px,0px)"}, {duration:scrollDuration})
				// document!.getElementById("carousel" + index)!.style.transform = "translate("+(0).toString()+"px,0px)"})
				document!.getElementById("carousel" + index)!.className = "bounceLeft"
				setTimeout(() => {
					document!.getElementById("carousel" + index)!.className = ""
				}, 2100);
			}
			else { //movement   
				document!.getElementById("carousel" + index)!.animate({ transform: "translate(" + increase.toString() + "px,0px)" }, { duration: scrollDuration }).finished.then(() => {
					document!.getElementById("carousel" + index)!.style.transform = "translate(" + increase.toString() + "px,0px)"
				})
			}
		}
		else {
			document!.getElementById("carousel" + index)!.style.zIndex = (999 - index).toString()
			let translate = document!.getElementById("carousel" + index)!.style.transform.slice(10)
			//console.log(translate)
			translate = translate.split("p")[0]
			//console.log(translate)
			let increase = parseInt(translate)
			increase += scrollSpeed
			//console.log(increase)
			if (increase < 0) {
				document!.getElementById("carousel" + index)!.animate({ transform: "translate(" + increase.toString() + "px,0px)" }, { duration: scrollDuration }).finished.then(() => {
					document!.getElementById("carousel" + index)!.style.transform = "translate(" + increase.toString() + "px,0px)"
				})
			}
			else if (increase > 0) { //end content list animation
				// document!.getElementById("carousel" + index)!.animate({transform: "translate("+(scrollSpeed).toString()+"px,0px)"}, {duration:scrollDuration}).finished.then(() =>{ 
				// document!.getElementById("carousel" + index)!.style.transform = "translate("+(scrollSpeed).toString()+"px,0px)"
				// document!.getElementById("carousel" + index)!.animate({transform: "translate("+(0).toString()+"px,0px)"}, {duration:scrollDuration})
				// document!.getElementById("carousel" + index)!.style.transform = "translate("+(0).toString()+"px,0px)"})
				document!.getElementById("carousel" + index)!.className = "bounceLeft"
				setTimeout(() => {
					document!.getElementById("carousel" + index)!.className = ""
				}, 2100);
			}
			else {
				document!.getElementById("carousel" + index)!.animate({ transform: "translate(" + increase.toString() + "px,0px)" }, { duration: scrollDuration }).finished.then(() => {
					document!.getElementById("carousel" + index)!.style.transform = "translate(" + increase.toString() + "px,0px)"
				})
			}
		}
	}


	private scrollRight = (index: number) => {

		let overflowingCarouselSpace = document!.getElementById("carousel" + index)!.offsetWidth - document!.getElementById("carouselContainer")!.offsetWidth

		if (document!.getElementById("carousel" + index)!.style.transform! === "") {
			document!.getElementById("carousel" + index)!.style.zIndex = (999 - index).toString()
			document!.getElementById("carousel" + index)!.style.transform = "translate(0px,0px)"
			let translate = document!.getElementById("carousel" + index)!.style.transform.slice(10)
			translate = translate.split("p")[0]
			let increase = parseInt(translate)
			increase += (-scrollSpeed)
			document!.getElementById("carousel" + index)!.animate({ transform: "translate(" + increase.toString() + "px,0px)" }, { duration: scrollDuration }).finished.then(() => {
				document!.getElementById("carousel" + index)!.style.transform = "translate(" + increase.toString() + "px,0px)"
			})
		}
		else {
			document!.getElementById("carousel" + index)!.style.zIndex = (999 - index).toString()
			let translate = document!.getElementById("carousel" + index)!.style.transform.slice(10)
			//console.log(translate)
			translate = translate.split("p")[0]
			//console.log(translate)
			let increase = parseInt(translate)
			increase += (-scrollSpeed)
			//console.log(increase)
			if (increase > -(overflowingCarouselSpace)) {
				document!.getElementById("carousel" + index)!.animate({ transform: "translate(" + increase.toString() + "px,0px)" }, { duration: scrollDuration }).finished.then(() => {
					document!.getElementById("carousel" + index)!.style.transform = "translate(" + increase.toString() + "px,0px)"
				})
			}
			else {
				document!.getElementById("carousel" + index)!.animate({ transform: "translate(" + (-(overflowingCarouselSpace) + -30).toString() + "px,0px)" },
					{ duration: 500 }).finished.then(() => {
						document!.getElementById("carousel" + index)!.style.transform = "translate(" + (-(overflowingCarouselSpace) + -30).toString() + "px,0px)"
					})
			}
		}
	}

	constructor(props: any) {
		super(props);

		this.contentListRef = React.createRef();
	}

	render() {

		const arrowIconCommonStyle: SxProps<Theme> = {
			fontSize: "50px",
			position: "absolute",
			height: "170px",
			width: "80px",
			alignSelf: "center",
			left: 0,
			zIndex: 9999,
			cursor: "pointer",
			backgroundColor: "rgba(0, 0, 0, 0.67)",
			color: process.env.REACT_APP_SECONDARY_COLOR
		}


		return (<Box sx={{ px: 5 }}>
			{this.props.contentLists.map((item, index) => (<Box key={item.id + "_" + Math.random()}>
				<Stack direction={"row"} spacing={2} sx={{ p: 1, mt: 2, mb: 2 }}>
					<Link to={`/list?contentListId=${item.id}`} style={{ textDecoration: "none" }}>
						<Typography variant={"h2"} color={"white"}
							sx={{
								fontWeight: "bold",
							}}>
							{item.title}
						</Typography>
					</Link>
				</Stack>
				<Box id="carouselContainer" display={"flex"} flexDirection={"row"} sx={{}}>
					{item.contents.length >= 5 && <ArrowLeftOutlined sx={arrowIconCommonStyle}
						style={{
						}}
						onClick={() => this.scrollLeft(index)
						 /*this.contentListRef!.current!.scrollLeft()*/} />}
					<Box
						ref={this.wrappingCarouselScrollRef}
						//id={"carousel" + index}
						sx={{
						}}
						style={{
							overflow: "visible",
							scrollbarWidth: "none"
						}}>
						<ContentList
							carouselId={index}
							ref={this.contentListRef}
							contentList={item} />
					</Box>
					{item.contents.length >= 5 && <ArrowRightOutlined sx={{
						fontSize: "50px",
						position: "absolute",
						height: "170px",
						width: "80px",
						right: 0,
						alignSelf: "center",
						zIndex: 9999,
						cursor: "pointer",
						backgroundColor: "rgba(0, 0, 0, 0.67)",
						color: process.env.REACT_APP_SECONDARY_COLOR
					}} onClick={() => this.scrollRight(index) /*this.contentListRef!.current!.scrollRight()
					*/} />}
				</Box>
			</Box>))}
		</Box>)
	}
}
